import { Dispatch } from 'redux'
import type { TUnderlyingDataExportDto } from '@homepal/api-contract'

import exportToExcel from 'utils/excel'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'

import { SnackbarMessage } from 'types/GlobalSnackbar'

export function tryExportDataXlsx(
  headers: string[],
  rows: { [key: string]: string | number | null }[],
  fileName: string,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    exportToExcel(headers, rows, fileName)
      .then(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.FileExported))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.FileExportedFailed))

        if (callback) {
          callback(true)
        }
      })
  }
}

// Follows a download link, which the server signs to download its file
// under the file's name.
function downloadFrom(url: string) {
  const link = document.createElement('a')

  link.href = url
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

/**
 * Runs an export on the server and downloads its file. The callback gets
 * the finished export, or null when it failed.
 */
export function tryExportDataOnServer(
  runExport: () => Promise<TUnderlyingDataExportDto>,
  callback?: (exported: TUnderlyingDataExportDto | null) => void
) {
  return (dispatch: Dispatch) => {
    runExport()
      .then((exported) => {
        downloadFrom(exported.url as string)
        dispatch(toggleSnackbarOpen(SnackbarMessage.FileExported))

        if (callback) {
          callback(exported)
        }
      })
      .catch(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.FileExportedFailed))

        if (callback) {
          callback(null)
        }
      })
  }
}

export const useUtilitiesActions = () => {
  return {
    tryExportDataXlsx: useThunkActions(tryExportDataXlsx),
    tryExportDataOnServer: useThunkActions(tryExportDataOnServer)
  }
}
